import script from "./performance.vue?vue&type=script&setup=true&lang=js"
export * from "./performance.vue?vue&type=script&setup=true&lang=js"

import "./performance.vue?vue&type=style&index=0&id=1e2fbfae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e2fbfae"]])

export default __exports__